import {h} from 'preact';

export default function EmailList({feedback, text, key}) {
	const emailList = feedback.map(email => {
		return <li key={key}>{email}</li>;
	});

	return (
		<span>{text}
			<ul>{emailList}</ul>
		</span>
	);
}
